if (!customElements.get('change-pod-bundle')) {
  customElements.define(
    'change-pod-bundle',
    class ChangePodBundle extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.productFormId);
        this.submitButton = this.querySelector('[data-bundle-submit]');
        this.status = this.querySelector('[data-bundle-status]');
        this.total = this.querySelector('[data-bundle-total]');
        this.items = Array.from(this.querySelectorAll('[data-bundle-item]'));
        this.currency = this.dataset.currency || 'JPY';

        const priceData = this.querySelector('[data-main-variant-prices]');
        try {
          this.mainVariantPrices = JSON.parse(priceData?.textContent || '{}');
        } catch (error) {
          this.mainVariantPrices = {};
        }

        this.items.forEach((item) => {
          const toggle = item.querySelector('[data-option-toggle]');
          const quantity = item.querySelector('[data-option-quantity]');
          const variant = item.querySelector('[data-option-variant]');
          const price = item.querySelector('[data-option-price]');

          toggle?.addEventListener('change', () => {
            quantity.disabled = !toggle.checked;
            item.classList.toggle('is-selected', toggle.checked);
            this.updateTotal();
          });
          quantity?.addEventListener('input', () => this.updateTotal());
          variant?.addEventListener('change', () => {
            const selected = variant.selectedOptions[0];
            if (!selected || !toggle) return;

            toggle.value = selected.value;
            toggle.dataset.price = selected.dataset.price || '0';
            if (price) price.textContent = this.formatMoney(Number(toggle.dataset.price) || 0);
            this.updateTotal();
          });
        });

        this.submitButton?.addEventListener('click', () => this.addBundle());
        this.form?.addEventListener('change', () => window.setTimeout(() => this.updateTotal(), 0));
        this.form?.querySelector('[name="quantity"]')?.addEventListener('input', () => this.updateTotal());
        this.updateTotal();
      }

      getMainItem() {
        const variantInput = this.form?.querySelector('[name="id"]');
        const quantityInput = this.form?.querySelector('[name="quantity"]');
        const id = Number(variantInput?.value);
        const quantity = Math.max(1, Number(quantityInput?.value) || 1);

        if (!id) return null;
        return { id, quantity };
      }

      getOptionItems() {
        return this.items.flatMap((item) => {
          const toggle = item.querySelector('[data-option-toggle]');
          const quantityInput = item.querySelector('[data-option-quantity]');
          if (!toggle?.checked || toggle.disabled) return [];

          return [{
            id: Number(toggle.value),
            quantity: Math.max(1, Number(quantityInput?.value) || 1),
          }];
        });
      }

      formatMoney(cents) {
        try {
          return new Intl.NumberFormat('ja-JP', {
            style: 'currency',
            currency: this.currency,
            maximumFractionDigits: this.currency === 'JPY' ? 0 : 2,
          }).format(cents / 100);
        } catch (error) {
          return `${Math.round(cents / 100).toLocaleString('ja-JP')}円`;
        }
      }

      updateTotal() {
        const mainItem = this.getMainItem();
        if (!mainItem || !this.total) return;

        let total = (Number(this.mainVariantPrices[String(mainItem.id)]) || 0) * mainItem.quantity;
        this.items.forEach((item) => {
          const toggle = item.querySelector('[data-option-toggle]');
          const quantity = item.querySelector('[data-option-quantity]');
          if (toggle?.checked) {
            total += (Number(toggle.dataset.price) || 0) * Math.max(1, Number(quantity?.value) || 1);
          }
        });
        this.total.textContent = this.formatMoney(total);
      }

      setStatus(message, isError = false) {
        if (!this.status) return;
        this.status.textContent = message;
        this.status.classList.toggle('is-error', isError);
      }

      async addBundle() {
        const mainItem = this.getMainItem();
        if (!mainItem) {
          this.setStatus('本体のカラーを選択してください。', true);
          return;
        }

        const items = [mainItem, ...this.getOptionItems()];
        const cartNotification = document.querySelector('cart-notification');
        const sections = cartNotification?.getSectionsToRender().map((section) => section.id) || [];
        const cartAddUrl = window.routes?.cart_add_url || '/cart/add.js';

        this.submitButton.disabled = true;
        this.submitButton.classList.add('loading');
        this.setStatus('カートに追加しています…');

        try {
          const response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              items,
              sections,
              sections_url: window.location.pathname,
            }),
          });
          const result = await response.json();

          if (!response.ok || result.status) {
            throw new Error(result.description || result.message || 'カートに追加できませんでした。');
          }

          this.setStatus(`${items.length}点をカートに追加しました。`);
          if (cartNotification && result.sections) {
            cartNotification.setActiveElement?.(this.submitButton);
            cartNotification.renderContents(result);
          } else {
            window.location.href = window.routes?.cart_url || '/cart';
          }
        } catch (error) {
          this.setStatus(error.message || 'カートに追加できませんでした。時間をおいて再度お試しください。', true);
        } finally {
          this.submitButton.classList.remove('loading');
          this.submitButton.disabled = false;
        }
      }
    }
  );
}

const initChangePodFilms = () => {
  document.querySelectorAll('[data-cpm-film]').forEach((video) => {
    if (video.dataset.cpmFilmReady === 'true') return;
    video.dataset.cpmFilmReady = 'true';

    const section = video.closest('.cpm-film');
    const toggle = section?.querySelector('[data-cpm-film-toggle]');
    const icon = toggle?.querySelector('[data-cpm-film-icon]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const updateButton = () => {
      if (!toggle || !icon) return;
      const isPaused = video.paused;
      toggle.setAttribute('aria-pressed', String(isPaused));
      toggle.setAttribute('aria-label', isPaused ? '動画を再生' : '動画を一時停止');
      icon.textContent = isPaused ? '▶' : 'Ⅱ';
    };

    if (reduceMotion) {
      video.pause();
      updateButton();
    } else {
      video.play().catch(updateButton);
    }

    video.addEventListener('play', updateButton);
    video.addEventListener('pause', updateButton);
    toggle?.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch(updateButton);
      } else {
        video.pause();
      }
    });

    updateButton();
  });
};

const initChangePodSceneGalleries = (scope = document) => {
  scope.querySelectorAll('[data-cpm-scenes]').forEach((gallery) => {
    if (gallery.dataset.cpmScenesReady === 'true') return;
    gallery.dataset.cpmScenesReady = 'true';

    const cards = Array.from(gallery.querySelectorAll('[data-cpm-scene]'));
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const desktopPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    let galleryIsVisible = false;

    const getParts = (card) => ({
      video: card.querySelector('[data-cpm-scene-video]'),
      playButton: card.querySelector('[data-cpm-scene-play]'),
      playIcon: card.querySelector('[data-cpm-scene-play-icon]'),
      soundButton: card.querySelector('[data-cpm-scene-sound]'),
      soundState: card.querySelector('[data-cpm-scene-sound-state]'),
    });

    const loadVideo = (card) => {
      const { video } = getParts(card);
      if (!video || video.dataset.cpmSceneLoaded === 'true') return video;

      video.src = video.dataset.src;
      video.preload = 'metadata';
      video.dataset.cpmSceneLoaded = 'true';
      video.load();
      return video;
    };

    const syncCard = (card) => {
      const { video, playButton, playIcon, soundButton, soundState } = getParts(card);
      if (!video) return;

      const isPlaying = !video.paused && !video.ended;
      const soundIsOn = !video.muted;
      card.classList.toggle('is-playing', isPlaying);
      card.classList.toggle('is-sound-on', soundIsOn);

      if (playButton) {
        playButton.setAttribute('aria-label', isPlaying ? '動画を一時停止' : '動画を再生');
        playButton.setAttribute('aria-pressed', String(isPlaying));
      }
      if (playIcon) playIcon.textContent = isPlaying ? 'Ⅱ' : '▶';

      if (soundButton) {
        soundButton.setAttribute('aria-label', soundIsOn ? '動画の音声をオフ' : '動画の音声をオン');
        soundButton.setAttribute('aria-pressed', String(soundIsOn));
      }
      if (soundState) soundState.textContent = soundIsOn ? 'ON' : 'OFF';
    };

    const pauseOtherCards = (activeCard) => {
      cards.forEach((card) => {
        if (card === activeCard) return;
        const { video } = getParts(card);
        video?.pause();
        if (video) video.muted = true;
        card.classList.remove('is-active');
        syncCard(card);
      });
    };

    const playCard = (card, { forceMuted = true } = {}) => {
      const video = loadVideo(card);
      if (!video) return;

      pauseOtherCards(card);
      card.classList.add('is-active');
      if (forceMuted) video.muted = true;

      const playPromise = video.play();
      if (playPromise) playPromise.catch(() => syncCard(card));
      syncCard(card);
    };

    const pauseGallery = () => {
      cards.forEach((card) => {
        const { video } = getParts(card);
        video?.pause();
        syncCard(card);
      });
    };

    cards.forEach((card) => {
      const { video, playButton, soundButton } = getParts(card);
      if (!video) return;

      video.muted = true;
      video.addEventListener('play', () => syncCard(card));
      video.addEventListener('pause', () => syncCard(card));
      video.addEventListener('volumechange', () => syncCard(card));

      playButton?.addEventListener('click', () => {
        if (video.paused) {
          playCard(card, { forceMuted: !card.classList.contains('is-active') });
        } else {
          video.pause();
        }
      });

      soundButton?.addEventListener('click', () => {
        const shouldEnableSound = video.muted;
        if (video.paused || !card.classList.contains('is-active')) {
          playCard(card, { forceMuted: false });
        }
        video.muted = !shouldEnableSound;
        syncCard(card);
      });

      card.addEventListener('pointerenter', () => {
        if (desktopPointer.matches && galleryIsVisible && !reduceMotion) {
          playCard(card);
        }
      });

      syncCard(card);
    });

    const defaultCard = gallery.querySelector('[data-cpm-scene-default]') || cards[0];
    if ('IntersectionObserver' in window) {
      const galleryObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            galleryIsVisible = entry.isIntersecting;
            if (!entry.isIntersecting) {
              pauseGallery();
            } else if (!reduceMotion && defaultCard && !cards.some((card) => getParts(card).video?.dataset.cpmSceneLoaded === 'true')) {
              playCard(defaultCard);
            }
          });
        },
        { rootMargin: '-12% 0px -12% 0px', threshold: 0.08 }
      );
      galleryObserver.observe(gallery);

      if (window.matchMedia('(max-width: 749px)').matches) {
        const scroller = gallery.querySelector('.cpm-scenes__grid');
        if (scroller) {
          const cardObserver = new IntersectionObserver(
            (entries) => {
              if (reduceMotion || !galleryIsVisible) return;
              const mostVisible = entries
                .filter((entry) => entry.isIntersecting)
                .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
              if (mostVisible?.intersectionRatio >= 0.62) playCard(mostVisible.target);
            },
            { root: scroller, threshold: [0.62, 0.8] }
          );
          cards.forEach((card) => cardObserver.observe(card));
        }
      }
    } else {
      galleryIsVisible = true;
      if (!reduceMotion && defaultCard) playCard(defaultCard);
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) pauseGallery();
    });
  });
};

const initChangePodPage = (scope = document) => {
  initChangePodFilms();
  initChangePodSceneGalleries(scope);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initChangePodPage());
} else {
  initChangePodPage();
}

document.addEventListener('shopify:section:load', (event) => initChangePodPage(event.target));
